<template>
    <answers ref="answers"
             code_question_group="GQ13"
             danger_code="MCAL33"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
